// Library methods
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { DateTime } from "luxon";

// Components
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// Utilities
import packageJson from "../../../../../package.json";

// Contexts
import { useClinicContext } from "src/contexts/clinic/ClinicProvider";

const Footer = () => {
  const { t } = useTranslation();
  const { clinicInfo } = useClinicContext();

  return (
    <Box
      id="footer-container"
      sx={{
        width: "100%",
        color: "#FFF",
        backgroundColor: "#202338",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column-reverse", sm: "row" },
          alignItems: { xs: "center", sm: "flex-end" },
          justifyContent: "space-between",
          my: "16px",
          mx: "24px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          <Link
            to="/privacy-policy"
            target="_blank"
            style={{
              fontSize: "14px",
              color: "#E2772E",
              textDecoration: "underline",
            }}
          >
            {t("Privacy Policy")}
          </Link>
          <Link
            to="/terms-and-conditions"
            target="_blank"
            style={{
              fontSize: "14px",
              color: "#E2772E",
              textDecoration: "underline",
            }}
          >
            {t("Terms and Conditions")}
          </Link>
        </Box>
        <Box sx={{ textAlign: { xs: "center", sm: "right" } }}>
          <Typography fontSize="14px">{`v${packageJson.version || "3.0"}`}</Typography>
          <Typography fontSize="14px">
            {`©${DateTime.now().setZone(clinicInfo?.timezone ?? DateTime.local().zoneName).year} Retinalogik Inc. ${t("All rights reserved")}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
